import _regenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import draggable from 'vuedraggable';
import { mapGetters, mapState } from 'vuex';
export default {
  components: {
    draggable: draggable
  },
  data: function data() {
    return {
      isExpand: true,
      loading: true
    };
  },
  mounted: function mounted() {},
  computed: _objectSpread(_objectSpread({}, mapState({
    // componentList: (state) => state.design.componentGroup
    componentList: function componentList(state) {
      var group = _.cloneDeep(state.design.componentGroup);
      var newGroup = group.map(function (item) {
        var list = item.componentList.filter(function (ch) {
          return typeof ch.draggable == 'undefined';
        });
        item.componentList = list;
        return item;
      });
      return newGroup;
    }
  })), mapGetters({
    curComponentNum: 'design/curComponentNum'
  })),
  methods: {
    /**
     * 展开，收缩分类数据
     * @param {Number|String} category_id 分类ID
     */
    handleSlide: function handleSlide(category_id) {
      if (this.selected_categorys.includes(category_id)) {
        this.selected_categorys = this.selected_categorys.filter(function (x) {
          return x !== category_id;
        });
      } else {
        this.selected_categorys.push(category_id);
      }
    },
    /**
     * 开始拖拽，复制拖拽对象
     * @param {Object} dragData 拖拽对象数据
     */
    createCloneComponent: function createCloneComponent(dragData) {
      var name = dragData.name,
        title = dragData.title,
        componentPack = dragData.componentPack,
        order = dragData.order,
        draggable = dragData.draggable,
        maxNum = dragData.maxNum,
        platform = dragData.platform,
        type = dragData.type;
      return {
        name: name,
        title: title,
        draggable: draggable,
        // location,
        componentPack: componentPack,
        platform: platform,
        order: order,
        type: type
      };
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            // 清除加载状态
            _this.loading = false;
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
};